module.exports = __webpack_public_path__ + "static/media/upShgMeetKan.a8d2bef2.jpg";